import { Component } from '@angular/core';

@Component({
    selector: 'app-commission-plan-rule-company-create',
    templateUrl: './commission-plan-rule-company-create.component.html',
    styleUrls: ['./commission-plan-rule-company-create.component.scss'],
    standalone: false
})
export class CommissionPlanRuleCompanyCreateComponent {}
